import { createTheme } from '@mui/material/styles';

const win95Theme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#C0C0C0', // Windows 95 gray
      paper: '#D3D3D3', // Medium gray for elements like modals or menus
    },
    primary: {
      main: '#000080', // Classic blue
    },
    secondary: {
      main: '#008080', // Teal accent
    },
    text: {
      primary: '#000000', // Black text
      secondary: '#808080', // Gray text
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "MS Sans Serif", Arial, sans-serif', // Classic Windows 95 font
    fontSize: 14,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#000000',
          backgroundColor: '#C0C0C0',
          border: '1px solid #808080', // Dark gray border
          boxShadow: 'inset -1px -1px #FFFFFF, inset 1px 1px #808080', // Embossed effect
          textTransform: 'none', // No uppercase
          '&:hover': {
            backgroundColor: '#A0A0A0', // Slightly darker gray
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#FFFFFF', // White input background
            border: '1px solid #808080', // Dark gray border
            boxShadow: 'inset -1px -1px #FFFFFF, inset 1px 1px #808080', // Embossed effect
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#000080', // Classic blue on hover
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#C0C0C0', // Gray background
          color: '#000000', // Black text
          boxShadow: 'none', // Flat appearance
          borderBottom: '2px solid #808080', // Dark gray border
        },
      },
    },
  },
});

export default win95Theme;